const DropzoneUpload = class DropzoneUpload{
    constructor(configDropzone){
        this.dropzoneWrapper = configDropzone.dropzoneWrapper;
    }

    init(){
        $(this.dropzoneWrapper).dropzone({
            url: "/",
            maxFilesize: 100,
            paramName: "uploadfile",
            maxThumbnailFilesize: 99999,
            maxFiles: 1,
            previewsContainer: ".js-image-previews",
            clickable: ['.js-upload-image', '.js-image-previews'],
            thumbnailWidth: 180,
            thumbnailHeight: 180,
            init: function() {
                this.on("maxfilesexceeded", function(file) {
                    this.removeAllFiles();
                    this.addFile(file);
                });
                // this.on('completemultiple', function(file, json) {
                //
                // });
                // this.on('success', function(file, json) {
                //
                // });
                //
                // this.on('addedfile', function(file) {
                //
                // });
                //
                // this.on('drop', function(file) {
                //
                // });
            }
        });

    }
}
export {DropzoneUpload};


// WEBPACK FOOTER //
// ./static/js/components/DropzoneUpload.js